import { aiTagsPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { AITagMaster } from '@/common/model/recommend/aiTag'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import TagForm from '@/components/container/form/modules/recommend/tag/TagForm'

interface Props {
  tag?: AITagMaster
  onRefetch?: () => void
}

const TagEditPage = ({ tag, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={aiTagsPath(siteId)} />
      <TagForm siteId={siteId} tag={tag} onRefetch={onRefetch} />
    </Main>
  )
}

export default TagEditPage
